module.exports = __webpack_public_path__ + "img/search.64ed4065.png";